import { render, staticRenderFns } from "./DetailKasbonDriver.vue?vue&type=template&id=772678c8"
import script from "./DetailKasbonDriver.vue?vue&type=script&lang=js"
export * from "./DetailKasbonDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports